<script setup lang="ts" name="BasePage">
import BaseCardLoading from '~/components/BaseCardLoading.vue';
import BasePageHeader from '~/components/BasePageHeader.vue';
import BasePageLayout from '~/components/BasePageLayout.vue';

import type { IMaintenanceArea, IPageAction, IPageBackButton } from '~/types';

const {
  title = '',
  lastUpdated,
  subTitle = '',
  actions = [],
  loading = false,
  withAside = false,
  spacing = true,
  withPattern = false,
  subTitlePilled = false,
  titleCapitalize,
  fullHeight,
} = defineProps<{
  title?: string;
  subTitle?: string;
  spacing?: boolean;
  lastUpdated?: number | null;
  backButton?: IPageBackButton;
  actions?: IPageAction[];
  loading?: boolean;
  withAside?: boolean;
  withPattern?: boolean;
  subTitlePilled?: boolean;
  areaId?: IMaintenanceArea;
  titleCapitalize?: boolean;
  fullHeight?: boolean;
}>();
</script>

<template>
  <BasePageLayout>
    <slot name="header">
      <BasePageHeader
        :title="title"
        :subTitle="subTitle"
        :spacing="spacing"
        :lastUpdated="lastUpdated"
        :backButton="backButton"
        :actions="actions"
        :loading="loading"
        :withPattern="withPattern"
        :subTitlePilled="subTitlePilled"
        :areaId="areaId"
        :titleCapitalize="titleCapitalize"
      >
        <template #button>
          <slot name="button" />
        </template>

        <template #heading>
          <slot name="heading" />
        </template>
      </BasePageHeader>
    </slot>

    <BaseCardLoading v-if="loading" class="col-span-full" />

    <template v-else-if="withAside">
      <main class="col-span-full lg:col-span-8 2xl:col-span-12">
        <div class="base-page-flex-gap" :class="{ 'h-full': fullHeight }">
          <slot />
        </div>
      </main>

      <aside class="col-span-full lg:col-span-4 2xl:col-span-4">
        <slot name="aside" />
      </aside>
    </template>

    <slot v-else />
  </BasePageLayout>
</template>
